/**
 * UTF-16 Big Endian Encoding.
 *
 *
 * @beta
 */
export const UTF_16_BE = 'utf-16be'
